import { render } from "./table-header-col.vue?vue&type=template&id=23fa4b62&scoped=true"
import script from "./table-header-col.vue?vue&type=script&lang=js"
export * from "./table-header-col.vue?vue&type=script&lang=js"

import "./table-header-col.vue?vue&type=style&index=0&id=23fa4b62&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fa4b62"]])

export default __exports__